import React, { Component } from 'react'
import Asidebar from '../../components/aside/asidebar';
class Sidebar extends Component {
    render() {
        return (
            <Asidebar role={this.props.role}></Asidebar>
        )
    }
}

export default Sidebar
